export default __webpack_public_path__ + "static/media/icono_cumplimientos.464a1a9c.png";